import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classcat';
import { isLoading } from 'lib/redux-utils';
import Bingo from 'modules/Bingo';
import GameBoard from './GameBoard';
import './ticket.css';

// This must be the carousel animation delay

class Ticket extends Component {
  _onClick = () => {
    const { purchased, ticketSelect, refName, selected } = this.props;
    if (!purchased) {
      ticketSelect([refName], selected);
    }
  };

  render() {
    const {
      refName,
      rows,
      purchased,
      purchasedAt,
      ballsToGo,
      selected,
      priceLabel,
      dropped,
      loading,
      inView,
      index,
      xMore,
      inPlay,
      type,
      pictureNumbersImageUrl
    } = this.props;

    const ticketClass = classNames([
      {
        ticket: true,
        purchased: purchased,
        selected: selected
      }
    ]);
    const purchasedDate = purchasedAt && new Date(purchasedAt);
    const title =
      purchasedDate &&
      `Bought on ${purchasedDate.toLocaleDateString()} at ${purchasedDate.toLocaleTimeString()}`;

    return (
      <div
        id={index === 0 ? refName : null}
        className={ticketClass}
        onClick={loading ? null : this._onClick}
        title={title}
      >
        {inView && !xMore ? (
          <header className="ticket__header">
            {inPlay && dropped && dropped.length > 0 && <div>{ballsToGo} to go</div>}
            <div className="ticketId">{`#${refName}`}</div>
            <div className="ticketPrice">{priceLabel}</div>
          </header>
        ) : null}
        {inView && !xMore ? (
          <GameBoard
            rows={rows}
            type={type}
            purchased={purchased}
            selected={selected}
            dropped={inPlay ? dropped : undefined}
            pictureNumbersImageUrl={pictureNumbersImageUrl}
          />
        ) : null}
        {!inView || xMore ? (
          <div className="band-0">{xMore ? `And ${xMore} more tickets` : 'Loading...'}</div>
        ) : null}
      </div>
    );
  }
}

Ticket.propTypes = {
  dropped: PropTypes.arrayOf(PropTypes.number),
  inView: PropTypes.bool,
  purchased: PropTypes.bool,
  purchasedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool,
  inPlay: PropTypes.bool,
  loading: PropTypes.bool,
  xMore: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  maxToGo: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  ballsToGo: PropTypes.number,
  priceLabel: PropTypes.string,
  refName: PropTypes.string.isRequired,
  ticketSelect: PropTypes.func,
  rows: PropTypes.array,
  type: PropTypes.oneOf(['30', '75', '90']),
  pictureNumbersImageUrl: PropTypes.string
};

Ticket.defaultProps = {
  dropped: [],
  inView: false,
  purchased: false,
  selected: false,
  xMore: 0,
  inPlay: false,
  loading: false,
  purchasedAt: null,
  ballsToGo: null,
  type: null,
  priceLabel: null,
  ticketSelect: null,
  rows: [],
  pictureNumbersImageUrl: null
};

const mapStateToProps = (state, ownProps) => {
  const stage = Bingo.selectors.getWaitingStage(state, null, 'current');
  let ballsToGo = Bingo.selectors.getDabCount(ownProps.dropped, ownProps.rows, stage);
  const inPlay = Bingo.selectors.getInPlay(state);
  if (ballsToGo === null) {
    ballsToGo = ownProps.maxToGo;
  }
  ballsToGo = ownProps.maxToGo - ballsToGo;
  const loading =
    isLoading(state, Bingo.actionTypes.AT.PURCHASED_TICKETS._) ||
    isLoading(state, Bingo.actionTypes.AT.ASSIGNED_TICKETS._) ||
    isLoading(state, Bingo.actionTypes.AT.QUICK_BUY._) ||
    isLoading(state, Bingo.actionTypes.AT.BUY_SELECTED._);
  return { ballsToGo, inPlay, loading };
};

const TicketAdapter = connect(mapStateToProps, null, null, { forwardRef: true })(Ticket);

TicketAdapter.propTypes = {
  maxToGo: PropTypes.number.isRequired
};

export default TicketAdapter;
